import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { Observable, Subscriber } from 'rxjs';

@Component({
  selector: 'app-update-teacher-profile',
  templateUrl: './update-teacher-profile.component.html',
  styleUrls: ['./update-teacher-profile.component.scss']
})
export class UpdateTeacherProfileComponent implements OnInit {
  updateTeacherForm: FormGroup; tName: string;
  Session: string;
  Subject: any;
  college: any;
  name: any;
  ShowForTeacher: boolean;
  userType: string; collegeList: any;
  filteredCollegeList: any;
  dialogRef: MatDialogRef<any>;
  UserCollege: string;
  DepartmentList: any[];
  filteredDepartmentList: any[];
  filteredmapSubjectList: any;
  mapSubjectList: any;
  saveButton = true
  updateButton = false
  deleteButton: boolean;
  isUgApproval = false;
  isPgApproval = false;
  DesignationList: any;
  filterDesignationList: any;
  GenderList: any;
  filterGenderList: any;
  APIService: any;
  prepopulationId: any
  LoginIDD: any;
  prepopulationDeleteId: any;
  isreaddelete = false;
  isreadupdate = false;
  errormessage: any;
  filename: any;
  fileName: string;
  uploadDocUG: any
  uploadDocPG: any
  uploadDocPhoto: any
  uploadDocSign: any
  fileUploadUGData
  fileUploadPGData
  fileUploadPhotoData
  fileUploadSignata
  FileDataPG: boolean;
  FileDataUG: boolean;
  teacherCreate = true;
  teacherUpdate = true;
  teacherDelete = true;
  TstatusList: any;
  filterTstatusList: any;
  fcCodeList: any;
  filteredListFcCode: any; userPermission: any;
  utp: string;
  showAss: boolean;
  filterTeacherTypeList: any;
  TeacherTypeList: any;
  constructor(public umsService: UmsService, private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private modalPopupService: ModalpopService,
    private spinner: NgxSpinnerService, private dialog: MatDialog,) { }


  ngOnInit(): void {

    sessionStorage.getItem('usertypeee');
    //  this.tName = sessionStorage.getItem('TLoginName')
    this.Session = sessionStorage.getItem("session")
    sessionStorage.getItem('userId');
    // alert(sessionStorage.getItem('TLoginName'))
    this.updateTeacherForm = this.fb.group({
      FirstName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-z0-9-&]*$')]),
      MiddleName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-z0-9-&]*$')]),
      LastName: new FormControl('', [Validators.required, Validators.pattern('^[a-zA-z0-9-&]*$')]),
      Email: new FormControl('', [Validators.required, Validators.pattern('(?![0-9]+@)([A-Za-z0-9._%-]+)@([A-Za-z0-9-]+(\.[A-Za-z0-9-]+)*)\.[A-Za-z]{2,3}')]),
      MobileNo: new FormControl('', [Validators.required, Validators.pattern('(0|91)?[6-9][0-9]{9}')]),
      DeptCode: new FormControl('', [Validators.required]),
      ToughtSubject: new FormControl('', [Validators.required]),
      OSACID: new FormControl(''),
      PGQualiPassYear: new FormControl('', [Validators.required]),
      // pgMonth: new FormControl(''),
      ApprovalStPG: new FormControl('', [Validators.required]),
      ApprovalStUG: new FormControl('', [Validators.required]),
      Guid: new FormControl('', [Validators.required]),
      PhdGuide: new FormControl('', [Validators.required]),
      DOB: new FormControl('', [Validators.required]),
      CgCode: new FormControl('', [Validators.required]),
      UGExpYears: new FormControl('', [Validators.required]),
      UGExpMonths: new FormControl('', [Validators.required]),
      UGExpDays: new FormControl('', [Validators.required]),
      PGExpYears: new FormControl('', [Validators.required]),
      PGExpMonths: new FormControl('', [Validators.required]),
      PGExpDays: new FormControl('', [Validators.required]),
      Initial: new FormControl('', [Validators.required]),
      Gender: new FormControl('', [Validators.required]),
      PANNo: new FormControl('', [Validators.required, Validators.pattern('([A-Z]){5}([0-9]){4}([A-Z]){1}$')]),
      AadharNo: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      Debar: new FormControl('', [Validators.required]),
      Designation: new FormControl('', [Validators.required]),
      isHOD: new FormControl('', [Validators.required]),
      //tepm not use
      TeacherPhoto: new FormControl(''),
      TeacherSign: new FormControl(''),
      UGApproval: new FormControl(''),
      PGApproval: new FormControl(''),
      PGExp: new FormControl(''),
      UGExp: new FormControl(''),
      FcCode: new FormControl(''),
      TeacherStatus: new FormControl(''),
      TeacherType: new FormControl(''),
    });
    // this.userPermission = JSON.parse(sessionStorage.getItem("userPermission")); 
    //   this.utp = sessionStorage.getItem('usertypeee');
    this.getUserData(sessionStorage.getItem('userId'))
    this.fetchFacultyCode();
    this.getCollege();
    this.fetchGenderList();
    this.fetchTeacherTypeList();
  }

  getUserData(id) {
    this.umsService.getUserData(id).subscribe((res) => {
      this.tName = res.data[0][0].LoginName;
      this.fetchSecretData();
      if (res.data[0][0].LoginLevel == 11) {
        this.userType = 'Super Admin'
      }
      else if (res.data[0][0].LoginLevel == 10) {
        this.userType = 'Admin'
      }
      else if (res.data[0][0].LoginLevel == 6) {
        this.userType = 'User'
      } else if (res.data[0][0].LoginLevel == 1) {
        this.userType = 'Teacher'
      }
      else {
        this.userType = 'Student'
      }
      if (this.userType == 'Teacher') {
        this.ShowForTeacher = true;
      } else {
        this.ShowForTeacher = false;
      }
    });
  }
  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.Session = res.projectPharam['SnNo']

      this.gwtTeacherInfo(this.Session);
      this.getTeacherProfileInfo(this.Session);
      this.getCollege();
      this.fetchGenderList();
    }
    );
  }
  gwtTeacherInfo(Session) {
    const payload = {};
    payload['MobileNo'] = this.tName;
    payload['SessionId'] = Session;
    this.umsService.getTeacherPerticular(payload).subscribe(res => {
      console.log('res.data', res.data)
      if (res.status) {
        this.name = res.data[0].Initial + '. ' + res.data[0].FirstName + ' ' + res.data[0].MiddleName + ' ' + res.data[0].LastName
        this.Subject = res.data[0].EsName;
        this.college = res.data[0].CgName;
        if (this.Subject == '' || this.Subject == null || this.Subject == undefined) {
          this.showAss = false;
        } else {
          this.showAss = true;
        }
      }
    })
  }

  fetchFacultyCode() {
    this.spinner.show()
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide()
        this.fcCodeList = res.data;
        this.filteredListFcCode = this.fcCodeList.slice();
      }
      else {
        this.spinner.hide()
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide()
    })
  }


  getCollege() {
    let payload = {}
    // if (this.userPermission[0].CgUi == 'C') {
    //   this.UserCollege = this.userPermission[0].CgId;
    // }
    // else {
    //   this.UserCollege = ''
    // }
    // payload['CgCode'] = this.UserCollege;
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      if (res.status) {
        this.collegeList = res.data;
        this.filteredCollegeList = this.collegeList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      let data = {};
      data['message'] = ERROR.error.message;
      data['title'] = 'Alert';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getDepartment(FcCode) {
    this.DepartmentList = [];
    this.filteredDepartmentList = [];
    this.mapSubjectList = [];
    this.filteredmapSubjectList = [];
    let payload = {}
    payload['FcCode'] = FcCode
    this.umsService.getDeptData(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.DepartmentList = res.data;
        this.filteredDepartmentList = this.DepartmentList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.DepartmentList = [];
    });
  }

  getDeptMapSubject(DeptCode) {
    this.mapSubjectList = [];
    this.filteredmapSubjectList = [];
    let payload = {}
    payload['DeptCode'] = DeptCode
    this.umsService.getDeptSubData(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.mapSubjectList = res.data;
        this.filteredmapSubjectList = this.mapSubjectList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();

    });
  }


  PgApproval(value) {
    if (value == 1) {
      this.isPgApproval = true
    } else {
      this.isPgApproval = false
    }

  }
  UgApproval(value) {
    if (value == 1) {
      this.isUgApproval = true
    } else {
      this.isUgApproval = false
    }
  }
  fetchGenderList() {
    const payload = {};
    payload['CdType'] = 'SX';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.GenderList = res.data;
        this.filterGenderList = this.GenderList.slice();
      } else {
      }
    });
  }


  getTeacherProfileInfo(Session) {
    const payload = {};
    payload['MobileNo'] = this.tName;
    //  payload['SessionId'] = Session;
    this.umsService.getTeacherPerticular(payload).subscribe(res => {
      console.log('res.data', res.data)
      const data = res.data[0];
      this.LoginIDD = data.LoginId
      this.prepopulationId = data.TechId;
      if (res.status) {
        this.spinner.hide();
        //  this.isread = true;
        //  this.deleteButton  = false;
        let appPG
        if (data.ApprovalStPG == true) {
          this.isPgApproval = true;
          appPG = 1
          if (data.PGDoc == '' || data.PGDoc == null || data.PGDoc == undefined) {
            this.FileDataPG = false
          } else {
            this.FileDataPG = true
          }
        } else {
          this.isPgApproval = false;
          appPG = 0
          this.FileDataPG = false
        }

        let appUG
        if (data.ApprovalStUG == true) {
          this.isUgApproval = true;
          appUG = 1;
          if (data.UGDoc == '' || data.UGDoc == null || data.UGDoc == undefined) {
            this.FileDataUG = false
          } else {
            this.FileDataUG = true
          }
        } else {
          this.isUgApproval = false
          appUG = 0
          this.FileDataUG = false
        }
        let Guid;
        if (data.Guid == true) {
          Guid = 1
        } else {
          Guid = 0
        }
        let PhdGuide;
        if (data.PhdGuide == true) {
          PhdGuide = 1
        } else {
          PhdGuide = 0
        }
        let Debar
        if (data.Debar == true) {
          Debar = 1
        } else {
          Debar = 0
        }
        let isHOD
        if (data.isHOD == true) {
          isHOD = 1
        } else {
          isHOD = 0
        }

        this.fileUploadUGData = data.UGDoc;
        this.fileUploadPGData = data.PGDoc;
        this.fileUploadPhotoData = data.TeacherPhoto;
        this.fileUploadSignata = data.TeacherSign;
        this.getDeptMapSubject(data.DeptCode);
        this.getDepartment(data.FcCode)
        let ToughtSubject
        if (data.ToughtSubject != null) {
          ToughtSubject = data.ToughtSubject.split(',');
        } else {
          ToughtSubject = data
        }

        this.updateTeacherForm = this.fb.group({
          FirstName: new FormControl(data.FirstName),
          MiddleName: new FormControl(data.MiddleName),
          LastName: new FormControl(data.LastName),
          DeptCode: new FormControl(data.DeptCode),
          CgCode: new FormControl(data.CgCode),
          MobileNo: new FormControl(data.MobileNo),
          ToughtSubject: new FormControl(ToughtSubject),
          Email: new FormControl(data.Email),
          OSACID: new FormControl(data.OSACID),
          Designation: new FormControl(data.Designation),
          PGQualiPassYear: new FormControl(data.PGQualiPassYear),
          // pgMonth: new FormControl(''),
          ApprovalStPG: new FormControl(appPG),
          ApprovalStUG: new FormControl(appUG),
          Guid: new FormControl(Guid),
          PhdGuide: new FormControl(PhdGuide),
          DOB: new FormControl(data.DOB),
          UGExpYears: new FormControl(data.UGExpYears),
          UGExpMonths: new FormControl(data.UGExpMonths),
          UGExpDays: new FormControl(data.UGExpDays),
          PGExpYears: new FormControl(data.PGExpYears),
          PGExpMonths: new FormControl(data.PGExpMonths),
          PGExpDays: new FormControl(data.PGExpDays),
          Initial: new FormControl(data.Initial),
          Gender: new FormControl(data.Gender),
          PANNo: new FormControl(data.PANNo),
          AadharNo: new FormControl(data.AadharNo),
          Debar: new FormControl(Debar),
          isHOD: new FormControl(isHOD),
          //tepm not use
          TeacherPhoto: new FormControl(data.TeacherPhoto),
          TeacherSign: new FormControl(data.TeacherSign),
          PGExp: new FormControl(data.PGExp),
          UGExp: new FormControl(data.UGExp),
          FcCode: new FormControl(data.FcCode),
          TeacherStatus: new FormControl(data.TeacherStatus),
          TeacherType: new FormControl(data.TeacherType)
        });
      } else {
        this.spinner.hide();
      }
    })
  }

  fileUploads: string[] = [];

  UGApproval($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;
    this.filename = '';  // Clear the filename
    // this.fileUploadData = '';
    // this.prepopulateDataAvailable = false;
    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
    else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (ext.toLowerCase() == "png" || ext.toLowerCase() == "jpg" || ext.toLowerCase() == "jpeg" || ext.toLowerCase() == "pdf") {
        this.convertToBase64(file);
      }
      else {
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }
  convertToBase64(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDocUG = d;

    });
  }
  readFile(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  PGApproval($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;
    this.filename = '';  // Clear the filename
    // this.fileUploadData = '';
    // this.prepopulateDataAvailable = false;
    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
    else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (ext.toLowerCase() == "png" || ext.toLowerCase() == "jpg" || ext.toLowerCase() == "jpeg" || ext.toLowerCase() == "pdf") {
        this.convertToBase64_2(file);
      }
      else {
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }
  convertToBase64_2(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile2(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDocPG = d;

    });
  }
  readFile2(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  TeacherPhoto($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;
    this.filename = '';  // Clear the filename
    // this.fileUploadData = '';
    // this.prepopulateDataAvailable = false;
    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
    else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (ext.toLowerCase() == "png" || ext.toLowerCase() == "jpg" || ext.toLowerCase() == "jpeg" || ext.toLowerCase() == "pdf") {
        this.convertToBase64_TeacherPhoto(file);
      }
      else {
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }
  convertToBase64_TeacherPhoto(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile_TeacherPhoto(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDocPhoto = d;

    });
  }
  readFile_TeacherPhoto(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }

  TeacherSign($event: Event) {
    const file = ($event.target as HTMLInputElement).files[0];
    const fileName = file.name;
    this.fileName = fileName;
    this.filename = '';  // Clear the filename
    // this.fileUploadData = '';
    // this.prepopulateDataAvailable = false;
    if (file.size >= 3000000) {
      this.errormessage = "Please upload file less than 3 MB";
      let data = {}
      data['message'] = this.errormessage
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      this.dialogRef.afterClosed().subscribe(result => {
        this.fileName = '';
        ($event.target as HTMLInputElement).value = '';
      });
    }
    else {
      this.errormessage = '';
      let ext = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (ext.toLowerCase() == "png" || ext.toLowerCase() == "jpg" || ext.toLowerCase() == "jpeg" || ext.toLowerCase() == "pdf") {
        this.convertToBase64_TeacherSign(file);
      }
      else {
        let data = {}
        data['message'] = 'File not support'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fileName = '';
          ($event.target as HTMLInputElement).value = '';
        });
      }
    }
  }
  convertToBase64_TeacherSign(file: File) {
    const observable = new Observable((subscriber: Subscriber<any>) => {
      this.readFile_TeacherSign(file, subscriber);
    });

    observable.subscribe((d) => {
      this.uploadDocSign = d;

    });
  }
  readFile_TeacherSign(file: File, subscriber: Subscriber<any>) {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      subscriber.next(fileReader.result);
      subscriber.complete();
    };
    fileReader.onerror = (error) => {
      subscriber.error(error);
      subscriber.complete();
    };
  }


  showbaseUGFile() {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: this.fileUploadUGData,
        disableClose: true
      });
  }
  showbasePGFile() {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: this.fileUploadPGData,
        disableClose: true
      });
  }
  showbasePhotoFile() {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: this.fileUploadPhotoData,
        disableClose: true
      });
  }
  showbaseSignFile() {
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: this.fileUploadSignata,
        disableClose: true
      });
  }

  update() {
    if (this.updateTeacherForm.invalid) {
      this.updateTeacherForm.get('FirstName').markAsTouched();
      this.updateTeacherForm.get('MiddleName').markAsTouched();
      this.updateTeacherForm.get('LastName').markAsTouched();
      this.updateTeacherForm.get('Email').markAsTouched();
      this.updateTeacherForm.get('MobileNo').markAsTouched();
      this.updateTeacherForm.get('DeptCode').markAsTouched();
      this.updateTeacherForm.get('ToughtSubject').markAsTouched();
      this.updateTeacherForm.get('PGQualiPassYear').markAsTouched();
      this.updateTeacherForm.get('ApprovalStPG').markAsTouched();
      this.updateTeacherForm.get('ApprovalStUG').markAsTouched();
      this.updateTeacherForm.get('Guid').markAsTouched();
      this.updateTeacherForm.get('PhdGuide').markAsTouched();
      this.updateTeacherForm.get('DOB').markAsTouched();
      this.updateTeacherForm.get('CgCode').markAsTouched();
      this.updateTeacherForm.get('UGExpYears').markAsTouched();
      this.updateTeacherForm.get('UGExpMonths').markAsTouched();
      this.updateTeacherForm.get('UGExpDays').markAsTouched();
      this.updateTeacherForm.get('PGExpYears').markAsTouched();
      this.updateTeacherForm.get('PGExpMonths').markAsTouched();
      this.updateTeacherForm.get('PGExpDays').markAsTouched();
      this.updateTeacherForm.get('Initial').markAsTouched();
      this.updateTeacherForm.get('Gender').markAsTouched();
      this.updateTeacherForm.get('PANNo').markAsTouched();
      this.updateTeacherForm.get('AadharNo').markAsTouched();
      this.updateTeacherForm.get('Debar').markAsTouched();
      this.updateTeacherForm.get('Designation').markAsTouched();
      this.updateTeacherForm.get('isHOD').markAsTouched();
      this.updateTeacherForm.get('FcCode').markAsTouched();
    }
    else {
      this.spinner.show()
      let payload = this.updateTeacherForm.value;
      let toughtSubjectArr = payload.ToughtSubject.join(',');
      payload['ToughtSubject'] = toughtSubjectArr;
      payload['TechId'] = this.prepopulationId;
      payload['LoginId'] = this.LoginIDD;
      payload['UserId'] = parseInt(sessionStorage.getItem('userId'));
      payload['TeacherStatus'] = this.updateTeacherForm.value.TeacherStatus;
      payload['ApprovalDocuments'] = [
        { type: 'UG', file: this.uploadDocUG ? this.uploadDocUG : this.fileUploadUGData },
        { type: 'PG', file: this.uploadDocPG ? this.uploadDocPG : this.fileUploadPGData },
        { type: 'Photo', file: this.uploadDocPhoto ? this.uploadDocPhoto : this.fileUploadPhotoData },
        { type: 'Sign', file: this.uploadDocSign ? this.uploadDocSign : this.fileUploadSignata },
      ];
      this.umsService.updateTeachersData(payload).subscribe(res => {

        if (res.status) {
          this.spinner.hide()
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        } else {
          this.spinner.hide();
          let data = {}
          data['message'] = res.message
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

        }
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      });
    }

  }

  fetchTeacherTypeList() {
    const payload = {};
    payload['CdType'] = 'TEATY';
    this.umsService.fetchCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.TeacherTypeList = res.data;
        this.filterTeacherTypeList = this.TeacherTypeList.slice();
        this.updateTeacherForm.controls['TeacherType'].setValue('IS')
      } else {
      }
    });
  }
}

